<div class="relative" tabindex="0">
    <a
        [routerLink]="'/profile/change-password'"
        class="bg-secondary rounded-full h-9 w-9 grid place-content-center cursor-pointer hover:bg-secondary/75 border-secondary border transition-colors"
    >
        <app-icon name="bi:person" class="text-md leading-4 text-white" />
    </a>
</div>
